/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import {
  Menu,
  X,
  ChevronDown,
  Home,
  Heart,
  Info,
  List,
  Image,
  Droplets,
  Briefcase,
  FileText,
} from "lucide-react";

const committeeOptions = [
  {
    name: "কেন্দ্রীয়",
    value: "central",
  },
  {
    name: "কার্যকরী পরিষদ",
    value: "executive",
  },
  {
    name: "কক্সবাজার",
    value: "cox-bazar",
  },
  {
    name: "নোয়াখালী-লক্ষ্মীপুর",
    value: "noakhali-lakshmipur",
  },
];

const Navbar = () => {
  const { pathname } = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const navigate = useNavigate();

  // Array of refs for dropdowns
  const dropdownRefs = useRef([]);

  // Helper for assigning refs to dropdown menus
  const setDropdownRef = (el, idx) => {
    dropdownRefs.current[idx] = el;
  };

  const toggleDropdown = (index) => {
    if (openDropdown === index) {
      setOpenDropdown(null);
    } else {
      setOpenDropdown(index);
    }
  };

  const closeAllDropdowns = () => {
    setOpenDropdown(null);
    setIsMenuOpen(false);
  };

  const handleClickOutside = (event) => {
    if (
      openDropdown !== null &&
      dropdownRefs.current[openDropdown] &&
      !dropdownRefs.current[openDropdown].contains(event.target)
    ) {
      setOpenDropdown(null);
    }
  };

  useEffect(() => {
    if (!isMenuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openDropdown, isMenuOpen]);

  // Route mappings
  const aboutPageElement = [
    "/about",
    "/adviser",
    "/member",
    "/rules",
    "/vision-mission",
    "/questions-answers",
  ];

  const listPageElement = [
    "talent-students",
    "public-university-students",
    "volunteer-list",
    "freelancer",
    "training-center",
    "donor-partner",
  ];

  const mediaPageElement = [
    "/media/photo-gallery",
    "/media/video-gallery",
    "/media/latest-notice",
    "newspaper-news",
  ];

  const bloodDonationPageElement = ["/blood-donor", "/join"];

  const donationPageElement = [
    "/donation",
    "/sponsor-info",
    "/about-donation",
    "sponsor-chile",
    "sponsor",
    "bank-info",
  ];

  const applicationElement = [
    "/scholarship-application",
    "/meritorious-student",
  ];

  // Helper function to check active routes
  const isActive = (routes) => {
    return routes.some(
      (route) => pathname === route || pathname.includes(route)
    );
  };

  // Organized navigation menu items
  const navItems = [
    {
      name: "হোম",
      icon: <Home size={20} />,
      path: "/",
      isDropdown: false,
    },
    {
      name: "আমাদের সম্পর্কে",
      icon: <Info size={20} />,
      isDropdown: true,
      isActive: isActive(aboutPageElement),
      items: [
        { name: "আমাদের সম্পর্কে", path: "/about" },
        { name: "বিধি মালা", path: "/rules" },
        { name: "লক্ষ ও উদ্দেশ্য", path: "/vision-mission" },
        { name: "প্রয়োজনীয় প্রশ্ন ও উত্তর", path: "/questions-answers" },
      ],
    },
    // {
    //   name: "তালিকা",
    //   icon: <List size={20} />,
    //   isDropdown: true,
    //   isActive: isActive(listPageElement),
    //   items: [
    //     { name: "মেধাবী শিক্ষার্থীর তালিকা", path: "/talent-students" },
    //     {
    //       name: "বিভিন্ন পাবলিক বিশ্ববিদ্যালয়ের শিক্ষার্থীর তালিকা",
    //       path: "/public-university-students",
    //     },
    //     { name: "ফ্রিল্যান্সার", path: "/freelancer" },
    //     { name: "ট্রেনিং সেন্টার", path: "/training-center" },
    //     { name: "ডোনার এন্ড পার্টনার", path: "/donor-partner" },
    //     { name: "স্বেচ্ছাসেবক তালিকা", path: "/volunteer-list" },
    //   ],
    // },
    {
      name: "মিডিয়া",
      icon: <Image size={20} />,
      isDropdown: true,
      isActive: isActive(mediaPageElement),
      items: [
        { name: "ভিডিও গ্যালারী", path: "/media/video-gallery" },
        { name: "সর্বশেষ বিজ্ঞপ্তী", path: "/media/latest-notice" },
        // {
        //   name: "বিভিন্ন পত্রিকায় প্রকাশিত সংবাদ",
        //   path: "/media/newspaper-news",
        // },
        { name: "প্রাপ্ত পুরষ্কার সমূহ", path: "/media/get-prize" },
      ],
    },
    {
      name: "ব্লাড ডোনেশন",
      icon: <Droplets size={20} />,
      isDropdown: true,
      isActive: isActive(bloodDonationPageElement),
      items: [
        { name: "ব্লাড ডোনারের তালিকা", path: "/blood-donor" },
        {
          name: "ব্লাড ডোনার হিসাবে নিবন্ধন করুন",
          path: "/blood-donor-register",
        },
      ],
    },
    {
      name: "প্রকল্প",
      icon: <Briefcase size={20} />,
      path: "/projects",
      isDropdown: false,
    },
    // {
    //   name: "প্রকল্প",
    //   icon: <Briefcase size={20} />,
    //   isDropdown: true,
    //   isActive: isActive(projectPageElement),
    //   items: [
    //     {
    //       name: "নিঃস্বার্থ নবজীবন সংগঠন (NNS) পাঠাগার",
    //       path: "/library-project",
    //     },
    //     { name: "বৃক্ষরোপণ কর্মসূচি", path: "/tree-plantation-project" },
    //     { name: "সবার জন্য কুরবানী", path: "/animal-sacrifice-project" },
    //     { name: "শিক্ষা", path: "/education-project" },
    //     { name: "খাদ্য", path: "/food-project" },
    //     { name: "শীতার্তদের শীতবস্ত্র", path: "/cloth-project" },
    //     { name: "কৃতি শিক্ষার্থীদের সংবর্ধনা", path: "/talent-student-award" },
    //   ],
    // },
    {
      name: "দান",
      icon: <Heart size={20} />,
      isDropdown: true,
      isActive: isActive(donationPageElement),
      items: [
        { name: "দান করুন", path: "/donation" },
        // { name: "দানের ব্যাখ্যা", path: "/about-donation" },
        // { name: "স্পন্সর করুন", path: "/sponsor-info" },
        { name: "Sponsor A Child", path: "/sponsor-child" },
      ],
    },
    {
      name: "আবেদন",
      icon: <FileText size={20} />,
      isDropdown: true,
      isActive: isActive(applicationElement),
      items: [
        { name: "শিক্ষা বৃত্তির আবেদন", path: "/scholarship-application" },
        { name: "শিক্ষার্থী সংবর্ধনা", path: "/meritorious-student" },
      ],
    },
    {
      name: "কমিটি",
      icon: <List size={20} />,
      isDropdown: true,
      isActive: isActive(listPageElement),
      items: [
        ...committeeOptions.map((option) => ({
          name: `${option.name} কমিটি`,
          path: `/committee?type=${option.value}`,
        })),
      ],
    },
  ];

  return (
    <nav className="bg-primary text-white shadow-md sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div></div>
          {/* Desktop Navigation */}
          <div className="hidden lg:flex lg:items-center lg:space-x-1">
            {navItems.map((item, index) => (
              <div
                key={index}
                className="relative"
                ref={
                  item.isDropdown && openDropdown === index
                    ? (el) => setDropdownRef(el, index)
                    : null
                }
              >
                {item.isDropdown ? (
                  <>
                    <button
                      onClick={() => toggleDropdown(index)}
                      className={`flex items-center px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 ${
                        item.isActive
                          ? "text-white font-bold"
                          : "text-white hover:text-primary hover:bg-gray-50"
                      }`}
                    >
                      <span className="mr-1">{item.icon}</span>
                      {item.name}
                      <ChevronDown size={16} className="ml-1" />
                    </button>
                    {openDropdown === index && (
                      <div className="absolute right-0 mt-2 w-56 bg-white rounded-md shadow-lg overflow-hidden z-10">
                        <div className="py-1">
                          {item.items.map((subItem, subIndex) => (
                            <NavLink
                              key={subIndex}
                              to={subItem.path}
                              onClick={closeAllDropdowns}
                              className={({ isActive }) =>
                                `block px-4 py-2 text-sm ${
                                  isActive
                                    ? "bg-gray-100 text-primary font-bold"
                                    : "text-gray-700 hover:bg-gray-50 hover:text-primary"
                                }`
                              }
                            >
                              {subItem.name}
                            </NavLink>
                          ))}
                        </div>
                      </div>
                    )}
                  </>
                ) : (
                  <NavLink
                    to={item.path}
                    className={({ isActive }) =>
                      `flex items-center px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 ${
                        isActive
                          ? "text-white font-bold"
                          : "text-white hover:text-primary hover:bg-gray-50"
                      }`
                    }
                  >
                    <span className="mr-1">{item.icon}</span>
                    {item.name}
                  </NavLink>
                )}
              </div>
            ))}
          </div>

          {/* Blood Donor Button */}
          <div className="hidden lg:flex lg:items-center">
            <NavLink
              to="/blood-donor"
              className="ml-4 px-4 py-2 rounded-md text-sm font-medium bg-red-500 text-white hover:bg-red-600 transition duration-150 ease-in-out flex items-center border-4 border-white"
            >
              <Droplets size={16} className="mr-1" />
              Blood Donor
            </NavLink>
          </div>

          {/* Mobile menu button */}
          <div className="flex items-center lg:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="p-2 rounded-md text-gray-700 hover:text-white hover:bg-gray-50 focus:outline-none"
            >
              {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu, show/hide based on menu state */}
      {isMenuOpen && (
        <div className="lg:hidden bg-white shadow-lg">
          <div className="px-2 pt-2 pb-3 space-y-1">
            {navItems.map((item, index) => (
              <div key={index}>
                {item.isDropdown ? (
                  <>
                    <button
                      onClick={() => toggleDropdown(index)}
                      className={`w-full flex items-center justify-between px-3 py-2 rounded-md text-base font-medium ${
                        item.isActive
                          ? "text-primary bg-gray-100 font-bold" // Changed to match desktop
                          : "text-gray-700 hover:text-primary hover:bg-gray-50" // Changed to match desktop
                      }`}
                    >
                      <div className="flex items-center">
                        <span className="mr-2">{item.icon}</span>
                        {item.name}
                      </div>
                      <ChevronDown size={16} />
                    </button>
                    {openDropdown === index && (
                      <div className="ml-4 mt-1 space-y-1">
                        {item.items.map((subItem, subIndex) => (
                          <NavLink
                            key={subIndex}
                            to={subItem.path}
                            onClick={(e) => {
                              e.preventDefault(); // Prevent default first
                              navigate(subItem.path); // Programmatically navigate
                              closeAllDropdowns(); // Then close dropdowns
                            }}
                            className={({ isActive }) =>
                              `block px-3 py-2 rounded-md text-base ${
                                isActive
                                  ? "text-primary bg-gray-100 font-bold" // Changed to match desktop
                                  : "text-gray-600 hover:bg-gray-50 hover:text-primary" // Changed to match desktop
                              }`
                            }
                          >
                            {subItem.name}
                          </NavLink>
                        ))}
                      </div>
                    )}
                  </>
                ) : (
                  <NavLink
                    to={item.path}
                    onClick={closeAllDropdowns}
                    className={({ isActive }) =>
                      `flex items-center px-3 py-2 rounded-md text-base font-medium ${
                        isActive
                          ? "text-primary bg-gray-100 font-bold" // Changed to match desktop
                          : "text-gray-700 hover:text-primary hover:bg-gray-50" // Changed to match desktop
                      }`
                    }
                  >
                    <span className="mr-2">{item.icon}</span>
                    {item.name}
                  </NavLink>
                )}
              </div>
            ))}
            <div className="pt-2">
              <NavLink
                to="/blood-donor"
                onClick={closeAllDropdowns}
                className="flex items-center justify-center w-full px-4 py-2 rounded-md text-base font-medium bg-red-500 text-white hover:bg-red-600"
              >
                <Droplets size={18} className="mr-2" />
                Blood Donor
              </NavLink>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
